import 'whatwg-fetch';

export function fetchWithAuth(...args) {
  const newHeaders = {
    Authorization: `Bearer ${window.localStorage.getItem('auth_token')}`,
    'Content-Type': 'application/json'
  };

  let opts = args[1];
  if (opts && opts.headers)
  {
    opts.headers = {...newHeaders, ...opts.headers}; //Allow callers to override the default auth headers and content-type defined above.
  } else if (opts) { 
    opts.headers = newHeaders;
  } else {
    opts = { headers: newHeaders };
  }
  return fetch(
    args[0], 
    opts);
}


//Special method used for posting files. 
//Content-Type needs to be handled by the browser automatically otherwise the content length isn't set properly.
export function postFile(...args) {
  const newHeaders = {
    Authorization: `Bearer ${window.localStorage.getItem('auth_token')}`,
  };

  let opts = args[1];
  if (opts && opts.headers)
  {
    opts.headers = {...newHeaders, ...opts.headers};
  } else if (opts) { 
    opts.headers = newHeaders;
  } else {
    opts = { headers: newHeaders };
  }
  return fetch(
    args[0], 
    opts);
}


// WEBPACK FOOTER //
// ./src/util/fetch.js